import React, { useState, useEffect } from 'react';
import { getAuth } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { VscArrowCircleRight, VscArrowCircleLeft } from "react-icons/vsc";
import { storage, db, auth } from '../Firebase/Firebase.js';
import { getDownloadURL, ref } from 'firebase/storage';
import { getFirestore, collection, doc, getDoc, addDoc, updateDoc, query, where, getDocs, setDoc } from "firebase/firestore";
import { useParams } from 'react-router-dom';
import DiseñoIzquierda from '../images/imgLateralIzquierdaEvento.png';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FaUsers, FaProjectDiagram, FaCalendar, FaStar, FaMapMarkerAlt, FaDollarSign, FaSearch } from 'react-icons/fa';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingScreen from '../Components/loading.js';
import './officerosania.css';
import { Timestamp } from "firebase/firestore";
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, TextField, Button } from "@mui/material";
import QRCodeGenerator from '../Components/QRcodeGenerator.js';
Modal.setAppElement('#root');
const ReservationsPage = () => {
    const { IdEspacio } = useParams();
    const [images, setImages] = useState([]);
    const [timeRange, setTimeRange] = useState([0, 24]); // [horaInicial, horaFinal]
    const [cost, setCost] = useState(0);
    const [totalCoins, setTotalCoins] = useState(0);

    const [iconUrl, setIconUrl] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [espacioData, setEspacioData] = useState(0);
    const [userId, setUserId] = useState(null);
    const [cedulaRucModalIsOpen, setCedulaRucModalIsOpen] = useState(false); // Nuevo estado para el modal de cédula o RUC
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [cedulaRuc, setCedulaRuc] = useState(""); // Para el input en el modal
    const [errorMessage, setErrorMessage] = useState(""); // Mensaje de error
    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false); // Modal de error
    const [successModalIsOpen, setSuccessModalIsOpen] = useState(false); // Modal de éxito
    const [reseñas, setReseñas] = useState([]);
    const [promedioCalificacion, setPromedioCalificacion] = useState(0);
    const [currentReseñaIndex, setCurrentReseñaIndex] = useState(0);
    const [horariosOcupados, setHorariosOcupados] = useState([]);
    const [isSelectingStartDate, setIsSelectingStartDate] = useState(true);
    const [loading, setLoading] = useState(true);
    const [fechaInicio, setFechaInicio] = useState();
    const [fechaFinal, setFechaFinal] = useState();
    const [horaInicio, setHoraInicio] = useState();
    const [horaFinal, setHoraFinal] = useState();
    const [userName, setUserName] = useState('');
    const [calendarId, setCalendarId] = useState('');
    const navigate = useNavigate();
    const [activeStartDate1, setActiveStartDate1] = useState(new Date());
    //Calendario
    const [selectedRange, setSelectedRange] = useState([new Date(), new Date()]);
    //cONSULTA HORARIOS DISPONIBLES
    const [horariosDisponibles, setHorariosDisponibles] = useState([]);
    const [fechaSeleccionada, setFechaSeleccionada] = useState(false);
    const [salasDisponibles, setSalasDisponibles] = useState([]);
    const [nPersonas, setNPersonas] = useState(0);
    const [alquilerPorSala, setAlquilerPorSala] = useState(false);
    const [opcionSeleccionada, setOpcionSeleccionada] = useState("precioSala");
    const [numeroPersonas, setNumeroPersonas] = useState("");
    const [qrCodeModalIsOpen, setQrCodeModalIsOpen] = useState(false);
    const [cedula, setCedula] = useState(0);
    const [ruc, setRuc] = useState(0);
    const handleChange = (event) => {
        setOpcionSeleccionada(event.target.value);
        if (event.target.value !== "pagoPorUso") {
            setNumeroPersonas("");
        }
    };
    useEffect(() => {
        const obtenerDatosEspacio = async () => {
            const auth = getAuth();
            const currentUser = auth.currentUser;
            if (currentUser) {
                const docRef = doc(db, "usuarios", currentUser.uid); // Reemplaza con tu colección y ID
                const docSnapU = await getDoc(docRef);

                if (docSnapU.exists()) {
                    setUserName(docSnapU.data().name + " " + docSnapU.data().lastName);
                }
            }
            const espacioDoc = doc(db, "espacios", IdEspacio);
            const docSnap = await getDoc(espacioDoc);
            if (docSnap.exists()) {
                setCalendarId(docSnap.data().calendarID);
            }
            if (docSnap.exists()) {
                const espacioData = docSnap.data();
                setEspacioData({
                    accesorios: espacioData.Accesorios,
                    capacidadMax: espacioData.CapacidadMax,
                    capacidadMin: espacioData.CapacidadMin,
                    color: espacioData.Color,
                    descripcion: espacioData.DescripcionEspacio,
                    nombre: espacioData.NombreEspacio,
                    IdtipoEspacio: espacioData.TipoEspacio,
                    lugar: espacioData.IdLugar,  // Obtenemos el IdLugar
                    cobroPorPersona: espacioData.cobroPorPersona,
                    costoCoinsPersonas: espacioData.costoCoinsPersonas,
                    costoEspHoraCoins: espacioData.costoEspHoraCoins,
                });
                // Después de obtener los datos de "espacios", hacemos una consulta a "lugar"
                const lugarDoc = doc(db, "lugar", espacioData.IdLugar);  // Usamos el IdLugar para obtener el NombreLugar
                const lugarSnap = await getDoc(lugarDoc);

                if (lugarSnap.exists()) {
                    const lugarData = lugarSnap.data();
                    setEspacioData((prevData) => ({
                        ...prevData,
                        nombreLugar: lugarData.NombreLugar,  // Actualizamos el estado con NombreLugar
                    }));
                } else {
                    // console.log("No se encontró el lugar con el ID proporcionado");
                }
                const espacioDoc = doc(db, "tipoespacio", espacioData.TipoEspacio);
                const tipoSnap = await getDoc(espacioDoc);
                if (tipoSnap.exists()) {
                    const tipoData = tipoSnap.data();
                    setEspacioData((prevData) => ({
                        ...prevData,
                        descripcionespacio: tipoData.DescripcionEspacio,  // Actualizamos el estado con Descripcion
                        tipoespacio: tipoData.TipoEspacio
                    }));

                    setLoading(false);
                } else {
                    alert("Ocurrió un error Inesperado, intenta nuevamente");
                    setLoading(false);
                    navigate("/")
                }
            }
            else {
                alert("Ocurrió un error Inesperado, intenta nuevamente");
                setLoading(false);
                navigate("/")
            }
        };


        const obtenerImagenes = async () => {
            const urls = [];
            for (let i = 1; i <= 4; i++) {
                const imageRef = ref(storage, `FotosEspacio/${IdEspacio}/${IdEspacio}${i}.png`);
                console.log(imageRef)
                try {
                    const url = await getDownloadURL(imageRef);
                    urls.push(url); // Si se obtiene la URL, se agrega al array

                } catch (error) {
                    // Si ocurre un error (por ejemplo, la imagen no existe), continúa con el siguiente formato
                    //console.error(`Error fetching image ${IdEspacio}${i}.png:`, error);
                }
            }
            setImages(urls);
            console.log(urls)
        };

        const obtenerIconos = async () => {
            const iconRef = ref(storage, `FotosEspacio/${IdEspacio}/${IdEspacio}logo.png`);
            try {
                const url = await getDownloadURL(iconRef);
                setIconUrl(url);
                return;
            } catch (error) {
                //console.error(`Error fetching icon ${IdEspacio}logo.png:`, error);
            }
            setIconUrl(null);
        };
        obtenerImagenes();
        obtenerIconos();
        obtenerDatosEspacio();
    }, [IdEspacio]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const getThumbnailImages = () => {
        let thumbnails = [];
        for (let i = 1; i < images.length; i++) {
            thumbnails.push(images[(currentIndex + i) % images.length]);
        }
        return thumbnails;
    };
    const openModal = (message, title) => {
        setModalTitle(title === 'positive' ? '¡Genial!' : '¡Lo sentimos !');
        setModalMessage(message);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };
    const handleReservation = async () => {
        const auth = getAuth();
        const currentUser = auth.currentUser;
        if (!currentUser) {

            openModal('Debes iniciar sesión para realizar una reserva.');
            return;
        }
        setUserId(currentUser.uid);
        try {
            const userRef = doc(db, 'usuarios', currentUser.uid);
            const docSnap = await getDoc(userRef);
            if (!docSnap.exists()) {
                return;
            }
            const userData = docSnap.data();
            // Validar cédula o RUC
            if (!userData.cedula && !userData.ruc) {
                setCedulaRucModalIsOpen(true);
                return;
            }


            if (userData.coins < parseInt(calcularCosto())) {
                openModal('No tienes suficientes coins para realizar la reserva.');
                return;
            }
            // Preparar los datos de la reserva
            const reservationData = {
                fechaInicio: formattedStartDate,
                fechaFinal: formattedEndDate,
                horaInicio: formatTime(horaInicio + 14),
                horaFinal: formatTime(horaFinal + 14),
                costoReserva: cost,
                idUser: currentUser.uid,
                IdEspacio: IdEspacio,
                reseñaRealizada: false,
                calUsers: false,
                fechaDeReserva: new Date(),
            };

            // Obtener datos del espacio desde la tabla 'espacios'
            const espacioDoc = await getDoc(doc(db, 'espacios', IdEspacio));
            if (!espacioDoc.exists()) {
                openModal("El espacio no existe.");
                return;
            }

            const espacioData = espacioDoc.data();
            const tipoEspacio = espacioData.TipoEspacio;
            const capacidadMax = espacioData.CapacidadMax;

            // Obtener el documento del contador de reservas
            const contadorDocRef = doc(db, 'contadorReservas', IdEspacio);
            const contadorDoc = await getDoc(contadorDocRef);
            let contadorReservas = contadorDoc.exists() ? contadorDoc.data().contador || 0 : 0;

            // Validación para tipoEspacio específico
            if (tipoEspacio === "tipoEspacio_pvozqd0m4") {
                if (contadorReservas >= capacidadMax) {
                    openModal('No hay cubículos disponibles para la fecha seleccionada.');
                    return;
                }

                // Actualizar el contador de reservas y agregar la reserva
                await setDoc(contadorDocRef, { contador: contadorReservas + 1 });
                await addDoc(collection(db, 'reservas'), reservationData);
                console.log(actualizarCosto())

                // Actualizar los coins del usuario en Firebase
                const newCoins = userData.coins - parseInt(calcularCosto());
                await updateDoc(userRef, { coins: newCoins });

                openModal('Reserva realizada con éxito.', 'positive');
                return;
            }

            // Validaciones para otros tipos de espacio
            await addDoc(collection(db, 'reservas'), reservationData);
            console.log(actualizarCosto())
            const newCoins = userData.coins - parseInt(calcularCosto());
            await updateDoc(userRef, { coins: newCoins });

            openModal('Reserva realizada con éxito.', 'positive');
            handleCrearEvento();

        } catch (error) {
            console.error("Error realizando la reserva:", error.message);
            openModal("Ocurrió un error al realizar la reserva. Por favor, intenta de nuevo más tarde.");
        }
    }


    const handleCrearEvento = () => {
        if (!fechaInicio || !fechaFinal || !horaInicio || !horaFinal) {
            alert("Por favor, completa todos los campos antes de crear el evento.");
            console.log(fechaInicio, fechaFinal, horaInicio, horaFinal);
            return;
        }
        crearEventoEnCalendario();

    };
    const formatTime = (value) => {
        const hours = Math.floor(value / 2);
        const minutes = (value % 2) * 30;
        return `${hours < 10 ? '0' : ''}${hours}:${minutes === 0 ? '00' : '30'}`;
    };

    const formattedStartDate = selectedRange[0]?.toLocaleDateString("es-ES", {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }) || 'No seleccionada';
    const formattedEndDate = selectedRange[1]?.toLocaleDateString("es-ES", {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }) || 'No seleccionada';
    const crearEventoEnCalendario = async () => {
        const url = "https://us-central1-laofi-f175b.cloudfunctions.net/createEventInCalendar";
        const data = {
            fechaInicio: formattedStartDate,
            fechaFinal: formattedEndDate,
            horaInicio: formatTime(horaInicio + 14),
            horaFinal: formatTime(horaFinal + 14),
            userName: userName,
            calendarId: calendarId
        };

        console.log(data);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw new Error("Error al crear el evento en el servidor.");
            }

            // No llamamos a response.json() si no es necesario
            // const eventData = await response.json(); // <- Puedes quitar esta línea si no la usas

            // Construye la URL para abrir Google Calendar con los datos del evento

            // Abre la nueva ventana con el formulario de creación de evento en Google Calendar

        } catch (error) {
            console.error("Error en la solicitud:", error);
        }
    };
    const convertDateToGoogleFormat = (date) => {
        const [day, month, year] = date.split('/');
        return `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}`;
    };
    const formatTimeForGoogleCalendar = (time) => {
        const [hour, minute] = time.split(':');  // Separar hora y minutos
        return `${hour}${minute}00`;  // Formato HHMMSS
    };
    const crearAgendaCalendarCliente = () => {
        const startDate = convertDateToGoogleFormat(formattedStartDate);  // Convertir la fecha de inicio
        const endDate = convertDateToGoogleFormat(formattedEndDate);      // Convertir la fecha de finalización

        const startDateTime = `${startDate}T${formatTimeForGoogleCalendar(formatTime(horaInicio + 14))}`;  // Combina la fecha de inicio con la hora
        const endDateTime = `${endDate}T${formatTimeForGoogleCalendar(formatTime(horaFinal + 14))}`;      // Combina la fecha de finalización con la hora

        // Crear la URL para Google Calendar
        const googleCalendarUrl = `https://calendar.google.com/calendar/u/0/r/eventedit?dates=${startDateTime}/${endDateTime}&text=Reserva%20de%20espacio%20para%20${espacioData.nombre}&details=Detalles%20del%20evento&location=&sf=true`;
        window.open(googleCalendarUrl, "_blank");
    }

    //OBTENER RESENAS
    useEffect(() => {
        if (!IdEspacio) {
            return; // Detener la ejecución si IdEspacio es undefined o vacío
        }


        const obtenerReseñas = async () => {
            const db = getFirestore();
            const reseñasRef = collection(db, 'reseñas');
            const q = query(reseñasRef, where('idEspacio', '==', IdEspacio)); // Filtro por IdEspacio
            try {
                const querySnapshot = await getDocs(q);
                let calificacionesTotales = 0;
                let contadorCalificaciones = 0;
                const reseñasFiltradas = [];
                for (const docSnap of querySnapshot.docs) {
                    const data = docSnap.data();
                    if (data.calificacion >= 4.5) {
                        // Buscar el nombre y apellido del usuario
                        const usuarioRef = doc(db, 'usuarios', data.userId); // Crear referencia al documento del usuario
                        const usuarioDoc = await getDoc(usuarioRef);
                        const usuarioData = usuarioDoc.exists() ? usuarioDoc.data() : { nombre: "Desconocido", apellido: "" };

                        reseñasFiltradas.push({
                            Reseña: data.Reseña,
                            calificacion: data.calificacion,
                            usuario: `${usuarioData.name} ${usuarioData.lastName}`.trim(),
                        });
                    }
                    calificacionesTotales += data.calificacion;
                    contadorCalificaciones++;
                }
                // Calcular el promedio de calificación
                const promedio = contadorCalificaciones > 0 ? calificacionesTotales / contadorCalificaciones : 0;
                setPromedioCalificacion(promedio);
                setReseñas(reseñasFiltradas); // Guarda las reseñas filtradas en el estado
            } catch (error) {
            }
        };
        obtenerReseñas();
    }, [IdEspacio]);
    const handleNextReseña = () => {
        setCurrentReseñaIndex((prevIndex) => (prevIndex + 1) % reseñas.length);
    };

    const handlePrevReseña = () => {
        setCurrentReseñaIndex((prevIndex) => (prevIndex - 1 + reseñas.length) % reseñas.length);
    };
    const handleDateChange = (date) => {
        setHoraInicio(null);
        setHoraFinal(null);
        //console.log('s',horaInicio, horaFinal)
        setFechaInicio(date);
        setFechaFinal(date);
        setFechaSeleccionada(true);
        setSelectedRange([date, date]);
        /*if (!fechaInicio || (fechaInicio && fechaFinal)) {
            // Si no hay fecha de inicio o ambas fechas ya están seleccionadas, reiniciar la selección
            setFechaInicio(date);
            setFechaFinal(null);
            setSelectedRange([date, null]);
            setFechaSeleccionada(false);
        } else if (!fechaFinal) {
            // Si ya hay una fecha de inicio, establecer la fecha final solo si es mayor
            if (date >= fechaInicio) {
                setFechaFinal(date);
                setSelectedRange([fechaInicio, date]);
                setFechaSeleccionada(true);
            } else {
                // Si la nueva fecha es menor que la fecha de inicio, intercambiarlas
                setFechaFinal(fechaInicio);
                setFechaInicio(date);
                setSelectedRange([date, fechaInicio]);
                setFechaSeleccionada(true);
            }
        }*/

    };
    //Para calcular cuando se hace el espacio por persona
    const incrementar = () => {
        if (nPersonas < espacioData.capacidadMax - 1) {
            setNPersonas(nPersonas + 1);
        }
    };

    const disminuir = () => {
        if (nPersonas > 1) {
            setNPersonas(nPersonas - 1);
        }
    };
    const calcularCosto = () => {
        let diferencia = horaFinal - horaInicio;
        if (diferencia % 2 === 0) {
            diferencia += 1; // Si es par, sumamos 1
        }
        let costoCalculado;
        if (opcionSeleccionada === "precioSala") {
            costoCalculado = espacioData.costoEspHoraCoins * (Math.ceil((diferencia) / 2)); // Suponiendo que hay un precioPorPersona
        } else {
            costoCalculado = nPersonas * espacioData.costoCoinsPersonas * (Math.ceil((diferencia) / 2)); // Suponiendo que hay un precioPorPersona
        }

        return costoCalculado;
    };

    const actualizarCosto = () => {
        const costoCalculado = calcularCosto();
        setCost(costoCalculado); // Solo se actualiza el costo cuando se llama explícitamente
    };

    useEffect(() => {

        if (!fechaInicio || !fechaFinal || !fechaSeleccionada) return;

        const fetchHorariosOcupados = async () => {
            try {
                //const fechaInicioString = new Date(fechaInicio).toISOString().split("T")[0];
                //const fechaFinalString = new Date(fechaFinal).toISOString().split("T")[0];

                //console.log("Filtrando entre:", fechaInicioString, "y", fechaFinalString);
                console.log("fecha Inicio", formattedStartDate);
                const querySnapshot = await getDocs(
                    query(
                        collection(db, "reservas"),
                        where("IdEspacio", "==", IdEspacio),
                        where("fechaInicio", "==", formattedStartDate),
                        //where("fechaFinal", "<=", formattedEndDate)
                    )
                );

                const ocupados = [];

                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    const startIndex = parseToIndex(data.horaInicio);
                    const endIndex = parseToIndex(data.horaFinal);

                    console.log("Reserva encontrada:", data);

                    for (let i = startIndex; i < endIndex; i++) {
                        ocupados.push(i);
                    }
                });

                setHorariosOcupados(Array.from(new Set(ocupados)));
            } catch (error) {
                console.error("Error obteniendo horarios ocupados:", error);
            }
        };

        fetchHorariosOcupados();
    }, [IdEspacio, fechaSeleccionada, fechaInicio, fechaFinal]);


    useEffect(() => {
        if (!fechaSeleccionada) return;

        const fetchSalasDisponibles = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "espacios"));
                const salasPromises = querySnapshot.docs.map(async (doc) => {
                    const sala = doc.data();
                    const salaId = doc.id;

                    // Convertir fechas a formato YYYY-MM-DD
                    const fechaSeleccionadaString = new Date(fechaSeleccionada).toISOString().split("T")[0];

                    // Consultar reservas de la sala actual
                    const reservasSnapshot = await getDocs(
                        query(
                            collection(db, "reservas"),
                            where("IdEspacio", "==", salaId),
                            // La reserva debe terminar después o en la fecha seleccionada
                        )
                    );

                    let salaOcupada = false;
                    let horariosOcupadosSala = [];
                    reservasSnapshot.forEach((reservaDoc) => {
                        const reserva = reservaDoc.data();
                        const startIndex = parseToIndex(reserva.horaInicio);
                        const endIndex = parseToIndex(reserva.horaFinal);
                        // Agregar los índices ocupados por esta sala
                        for (let i = startIndex; i < endIndex; i++) {
                            horariosOcupadosSala.push(i);

                        }
                    });

                    // Verificar si los horarios seleccionados están ocupados en esta sala
                    if (horariosOcupadosSala.some((hora) => horariosOcupados.includes(hora))) {
                        salaOcupada = true;
                        console.log(horariosOcupadosSala, horariosOcupados);
                    }

                    // Retorna la sala si está disponible
                    return salaOcupada ? null : { id: salaId, ...sala };
                });

                // Esperar todas las consultas
                const salasDisponibles = (await Promise.all(salasPromises)).filter((sala) => sala !== null);

                setSalasDisponibles(salasDisponibles);
            } catch (error) {
                console.error("Error obteniendo salas disponibles: ", error);
            }
        };

        fetchSalasDisponibles();
    }, [fechaSeleccionada, horariosOcupados, fechaInicio, fechaFinal]);


    useEffect(() => {
        // Generar los horarios en intervalos de 30 min (08:00 - 22:00)
        const horarios = [];
        for (let i = 14; i <= 40; i++) {
            // Índices representan 08:00 - 22:00 en pasos de 30 min
            /* if (!horariosOcupados.includes(i)) {*/
            horarios.push(parseToTime(i));
            /*}*/
        }
        setHorariosDisponibles(horarios);
    }, [horariosOcupados]);
    const handleSubmit = async () => {
        const validarIdentificacionEcuador = (identificacion) => {
            // Verificar longitud
            if (identificacion.length !== 10 && identificacion.length !== 13) {
                return "La identificación debe tener 10 o 13 dígitos.";
            }

            // Validar cédula (primeros 10 dígitos)
            const cedula = identificacion.substring(0, 10);

            // Validar región
            const digitoRegion = parseInt(cedula.substring(0, 2), 10);
            if (digitoRegion < 1 || digitoRegion > 24) {
                return "La cédula no pertenece a ninguna región válida.";
            }

            // Validar último dígito de la cédula
            const ultimoDigito = parseInt(cedula.substring(9, 10), 10);

            // Sumar pares
            const pares =
                parseInt(cedula.substring(1, 2), 10) +
                parseInt(cedula.substring(3, 4), 10) +
                parseInt(cedula.substring(5, 6), 10) +
                parseInt(cedula.substring(7, 8), 10);

            // Procesar impares
            const calcularImpar = (digito) => {
                const resultado = digito * 2;
                return resultado > 9 ? resultado - 9 : resultado;
            };

            const impares =
                calcularImpar(parseInt(cedula.substring(0, 1), 10)) +
                calcularImpar(parseInt(cedula.substring(2, 3), 10)) +
                calcularImpar(parseInt(cedula.substring(4, 5), 10)) +
                calcularImpar(parseInt(cedula.substring(6, 7), 10)) +
                calcularImpar(parseInt(cedula.substring(8, 9), 10));

            // Sumar total
            const sumaTotal = pares + impares;

            // Extraer primer dígito de la suma
            const primerDigitoSuma = parseInt(String(sumaTotal).substring(0, 1), 10);

            // Decena inmediata
            const decenaInmediata = (primerDigitoSuma + 1) * 10;

            // Calcular dígito validador
            let digitoValidador = decenaInmediata - sumaTotal;
            if (digitoValidador === 10) digitoValidador = 0;

            // Verificar dígito validador
            if (digitoValidador !== ultimoDigito) {
                return "La cédula no es válida.";
            }

            // Si tiene 13 dígitos, validar RUC
            if (identificacion.length === 13) {
                const ruc = identificacion.substring(10, 13);
                if (ruc !== "001") {
                    return "El RUC debe terminar en 001.";
                }
            }

            return null; // La identificación es válida
        };

        const errorMessage = validarIdentificacionEcuador(cedulaRuc);
        if (errorMessage) {
            setErrorMessage(errorMessage);
            setErrorModalIsOpen(true); // Mostrar el modal de error
        } else {
            if (cedulaRuc.length === 10) { // Validación para cédula
                await saveCedulaOrRuc(cedulaRuc, 'cedula');
                setModalIsOpen(false);
            } else if (cedulaRuc.length === 13) { // Validación para RUC
                await saveCedulaOrRuc(cedulaRuc, 'ruc');
                setModalIsOpen(false);
            }
        }
    };
    const handleChange2 = (e) => {
        const value = e.target.value;
        // Permitir solo números
        if (/^\d*$/.test(value)) {
            setCedulaRuc(value);
        }
    };
    const saveCedulaOrRuc = async (cedulaRuc, type) => {
        try {
            const userRef = doc(db, 'usuarios', userId);
            await updateDoc(userRef, {
                [type]: cedulaRuc, // Usar 'cedula' o 'ruc' según corresponda
            });

            // Actualizar el estado de cédula o RUC en el componente
            if (type === 'cedula') {
                setCedula(cedulaRuc);
                setCedulaRucModalIsOpen(false);
            } else {
                setRuc(cedulaRuc);
                setCedulaRucModalIsOpen(false);
            }

            // Mostrar modal de éxito
            setSuccessModalIsOpen(true); // Abrir el modal de éxito
        } catch (error) {
            console.error("Error guardando la cédula o RUC: ", error);
        }
    };


    const parseToIndex = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        return (hours * 2 + (minutes >= 30 ? 1 : 0) - 14); // Convierte a índice basado en 30 min
    };

    const parseToTime = (index) => {
        const hours = Math.floor((index) / 2);
        const minutes = index % 2 === 0 ? "00" : "30";
        return `${String(hours).padStart(2, "0")}:${minutes}`;
    };


    if (loading) {
        return <LoadingScreen></LoadingScreen>
    }
    const handleHoraClick = (index) => {
        if (horariosOcupados.includes(index)) return;

        if (horaInicio === null || (horaInicio !== null && horaFinal !== null)) {
            setHoraInicio(index);
            setHoraFinal(null);
            //setHoraSeleccionada(index); // Marca la hora seleccionada
        } else if (index > horaInicio) {
            setHoraFinal(index);
            //setHoraSeleccionada(null); // Limpiar selección al marcar el rango completo
        } else {
            setHoraInicio(index);
            setHoraFinal(null);
            //setHoraSeleccionada(index); // Marca la hora seleccionada
        }

    };

    return (
        <div>
            <Navbar />
            <ToastContainer />
            <br /><br />
            <div className="rosania_content">
                <div className="rosania_left">
                    <h1 className='rosania_left_titulo'>{espacioData.tipoespacio}</h1>
                    <h3 className='rosania_left_lugar'>{espacioData.nombreLugar}</h3>
                    <h3 className='rosania_left_space'>
                        {espacioData.nombre}
                        {iconUrl ? (
                            <img src={iconUrl} alt='logo' className="volcan_amarillo" />
                        ) : (
                            <span className="icon-placeholder"> {/* Este span puede ser un espacio vacío o un texto alternativo */}
                                {/* Aquí puedes dejarlo vacío o poner un texto como "logo no disponible" */}
                            </span>
                        )}
                    </h3>
                    <br></br>
                    <h1 className='rosania_left_esp'>
                        {espacioData.descripcion}
                    </h1>

                    <div className="other_images_container" style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
                        <button className="arrow_left" onClick={handlePrev}>
                            <VscArrowCircleLeft style={{ width: '30px', height: '30px', fill: 'black' }} />
                        </button>

                        <div className="other_images" style={{ display: 'flex', gap: '31px' }}>
                            {getThumbnailImages().map((image, index) => (
                                // eslint-disable-next-line jsx-a11y/alt-text
                                <img
                                    key={index}
                                    src={image}
                                    className={`Rosania${index + 1}`}
                                    style={{ cursor: 'pointer', width: '100px', height: '100px', borderRadius: '20px' }}
                                />
                            ))}
                        </div>


                        <button className="arrow_right" onClick={handleNext} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                            <VscArrowCircleRight style={{ width: '30px', height: '30px', fill: 'black' }} />
                        </button>
                    </div>

                    <img src={DiseñoIzquierda} alt='DiseñoIzquierda' className='DiseñoIzquierda' />
                </div>

                <div className="rosania_right">
                    <img
                        src={images[currentIndex]}
                        alt="Imagen Grande"
                        className="Rosania4"
                        style={{ width: '400px', height: '400px', borderRadius: '20px' }}
                    />
                </div>
            </div>
            <div className='gridReservacionPlace' style={{ marginTop: '2em' }}>
                <div className='grid_reseñaseinfo'>
                    <div className='p-4 bg-white shadow-md rounded-lg border-2 border-gray-400'>
                        <h2 className='textprincipaltab1' style={{ backgroundColor: espacioData.color || '#ffffff00' }}>
                            <br></br>{espacioData.descripcionespacio}
                        </h2>
                        <div className='flex'>
                            <div className=' p-4'>
                                {iconUrl ? (
                                    <img src={iconUrl} alt='logo' className='gridlogos' />
                                ) : (
                                    <span className='icon-placeholder'> {/* Este span puede ser un espacio vacío o un texto alternativo */}
                                        {/* Aquí puedes dejarlo vacío o poner un texto como "logo no disponible" */}
                                    </span>
                                )}
                            </div>
                            {/* Sección de Capacidad */}
                            <div className="flex flex-col justify-center items-center p-4">
                                <h3 className="text-xl font-bold mb-2">CAPACIDAD</h3>
                                <div className="flex flex-col items-center mb-2">
                                    <FaUsers style={{ color: espacioData.color || '#ffffff00', width: '2em', height: '2em', marginBottom: '0.5em' }} />
                                    <span className='capaciadespacios' style={{ fontSize: '28px', textAlign: 'center' }}>{espacioData.capacidadMin} - {espacioData.capacidadMax}</span>
                                </div>
                                <p className='palabraPersonas' style={{ marginBlockStart: '0em', textAlign: 'center' }}>Personas</p>
                            </div>
                            {/* Sección de Accesorios */}
                            <div className="flex flex-col justify-center items-center p-4">
                                <h3 className="text-xl font-bold mb-2">ACCESORIOS</h3>
                                <div className="flex flex-col items-center">
                                    <FaProjectDiagram style={{ color: espacioData.color || '#ffffff00', width: '2.5em', height: '2em', marginBottom: '0.2em', marginTop: '14px' }} className="text-orange-500" />
                                    <p className='accesorios_espacios' style={{ textAlign: 'center', fontSize: '21px' }}>{espacioData.accesorios}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div alt="reseñastemp" className="reseñastemp" style={{ backgroundColor: espacioData.color || '#dfb4515c' }}>
                        <div className='puntajeytituloReseñas'>
                            <h1 className='titulo_reseña'>Reseñas</h1>
                            <div className='calificacion_icono' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '24px', marginTop: '-40px' }}>
                                <FaStar style={{ color: '#ffffff', width: '50%', marginRight: '17px' }} />
                                <h2> {promedioCalificacion.toFixed(2)}</h2>

                            </div>
                        </div>
                        <div className='content_comentarios' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <button
                                className="arrow_left1"
                                onClick={handlePrevReseña}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: reseñas.length > 0 ? 'pointer' : 'not-allowed',
                                }}
                                disabled={reseñas.length === 0}
                            >
                                <VscArrowCircleLeft style={{ width: '30px', height: '30px', fill: 'black' }} />
                            </button>

                            {reseñas.length > 0 && reseñas[currentReseñaIndex] ? (
                                <div key={currentReseñaIndex} className="Reseña_por_usuario">
                                    <p className="textoReseña">{reseñas[currentReseñaIndex]?.usuario || 'Anónimo'}</p>
                                    <p className="textoReseña1">{reseñas[currentReseñaIndex]?.Reseña || 'Sin reseña disponible'}</p>
                                </div>
                            ) : (
                                <p>No hay reseñas disponibles</p>
                            )}


                            <button
                                className="arrow_right1"
                                onClick={handleNextReseña}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: reseñas.length > 0 ? 'pointer' : 'not-allowed',
                                }}
                                disabled={reseñas.length === 0}
                            >
                                <VscArrowCircleRight style={{ width: '30px', height: '30px', fill: 'black' }} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className='grid_reserva'>
                    <h2 className='ReservaTitulo' style={{ marginBottom: '20px' }}>RESERVAR</h2>
                    <p className='nombreLugar' style={{ textAlign: 'center', fontSize: '18px', marginTop: '-14px', marginBottom: '27px', textDecoration: 'underline' }}>{espacioData.nombre}</p>
                    <div className='ReservaFecha'>
                        <FaCalendar style={{ marginRight: '10px' }} />
                        <span>
                            {isSelectingStartDate
                                ? "Selecciona una fecha"
                                : ""}
                            <br />
                        </span>

                        <FaSearch style={{ marginLeft: '10px' }} />

                    </div>
                    <div className="calendar-container">
                        {/* Primer calendario (Mes actual) */}
                        <Calendar
                            onClickDay={handleDateChange}
                            minDate={new Date()}
                            className="react-calendar"
                            activeStartDate={activeStartDate1}
                            onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate1(activeStartDate)}
                            tileClassName={({ date, view }) => {
                                if (view === "month" && fechaInicio && date.toDateString() === fechaInicio.toDateString()) {
                                    return "selected-date"; // Clase CSS para resaltar la fecha seleccionada
                                }
                                return null;
                            }}
                        />
                    </div>

                    {fechaSeleccionada && (
                        <div className='horas-disponibles'>
                            <div className='grid-horarios'>

                                {horariosDisponibles.map((hora, index) => {
                                    const isOcupado = horariosOcupados.includes(index);
                                    const isSelected = horaInicio !== null &&
                                        ((horaFinal !== null && index >= horaInicio && index <= horaFinal) ||
                                            (horaFinal === null && index === horaInicio));
                                    return (

                                        <div
                                            key={index}
                                            className={`horario-celda ${isOcupado ? "ocupado" : ""} ${isSelected ? "selected" : ""}`}

                                            onClick={() => !isOcupado && handleHoraClick(index)} // Solo permite clic si no está ocupado
                                            title={isOcupado ? "Horario no disponible" : "Horario disponible"}
                                            data-value={hora}
                                        >
                                            <div className='encabezado-contenedor'>
                                                {hora}
                                            </div>
                                        </div>
                                    );
                                })}</div>

                            {horaInicio && horaFinal && (
                                horariosOcupados.some((index) => index >= horaInicio && index <= horaFinal) ? (
                                    <div className="opciones-adicionales">
                                        <h1 className="error">No puedes seleccionar horarios ocupados!!</h1>

                                        <h3>Tenemos estas opciones disponibles:</h3>

                                        {/* Opción 1: Seleccionar otra sala */}
                                        <div>
                                            <select>
                                                {salasDisponibles.map((sala) => (
                                                    <option key={sala.id} value={sala.id}>
                                                        {sala.NombreEspacio} - Capacidad: {sala.CapacidadMax}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                ) : (
                                    <FormControl>
                                        <FormLabel>Selecciona una opción</FormLabel>
                                        <RadioGroup value={opcionSeleccionada} onChange={handleChange}>
                                            <FormControlLabel
                                                value="precioSala"
                                                control={<Radio />}
                                                label={`Pagar el precio por Sala (Capacidad máxima de ${espacioData.capacidadMax} Personas)`}
                                            />
                                            <FormControlLabel value="pagoPorUso" control={<Radio />} label="Aprovecha pagando lo que usas" />
                                        </RadioGroup>

                                        {opcionSeleccionada === "pagoPorUso" && (
                                            <div>
                                                <p>Selecciona el número de personas (Máximo: {espacioData.capacidadMax - 1})</p>
                                                <div className="contador-personas">
                                                    <Button variant="contained" color="secondary" onClick={disminuir} disabled={nPersonas <= 1}>
                                                        -
                                                    </Button>
                                                    <span style={{ margin: "0 10px", fontSize: "18px" }}>{nPersonas}</span>
                                                    <Button variant="contained" color="primary" onClick={incrementar} disabled={nPersonas >= espacioData.capacidadMax - 1}>
                                                        +
                                                    </Button>
                                                </div>
                                                <p>Total a pagar: {calcularCosto()} coins</p> {/* Muestra el total basado en el número de personas */}
                                            </div>
                                        )}
                                        {opcionSeleccionada === "precioSala" && <p>Total a pagar: {calcularCosto()} coins</p>}
                                        {opcionSeleccionada === "pagoPorUso" && <p>Número de personas: {nPersonas}</p>}
                                        {opcionSeleccionada != null && (nPersonas > 0 || opcionSeleccionada === "precioSala") && <button className='confirmarReservacion' onClick={() => { handleReservation(); actualizarCosto(); }} >Reservar Ahora</button>}
                                    </FormControl>

                                )
                            )}


                        </div>

                    )}

                </div><Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    className={'MensajeReserva'}
                >
                    <h2 className={modalTitle === '¡Genial!' ? 'positive-message' : 'negative-message'}>
                        {modalTitle}
                    </h2>
                    <p>{modalMessage}</p>
                    <button
                        onClick={() => {
                            if (modalMessage === 'Debes iniciar sesión para realizar una reserva.') {
                                localStorage.setItem('reservation', 'true');
                                const urlActual = window.location.href;
                                localStorage.setItem("reservationUrl", urlActual);
                                navigate('/login');
                            } else if (modalMessage === 'Reserva realizada con éxito.') {
                                setQrCodeModalIsOpen(true);

                            } else {
                                closeModal(); // Cierra el modal si el mensaje no es de sesión
                            }
                        }}
                    >
                        Cerrar
                    </button>
                    {modalMessage === 'No tienes suficientes coins para realizar la reserva.' && (
                        <button
                            onClick={() => {
                                localStorage.setItem('reservationCoins', 'true');
                                const urlActual = window.location.href;
                                localStorage.setItem("reservationCoinsUrl", urlActual);
                                navigate('/portal-recargas');
                            }}
                            style={{ backgroundColor: 'green' }}
                        >
                            Recargar
                        </button>
                    )}
                </Modal>
            </div>
            <QRCodeGenerator
                isOpen={qrCodeModalIsOpen}
                onClose={() => {
                    setQrCodeModalIsOpen(false);  // Cierra el modal
                    navigate('/reservasRealizadas');
                    crearAgendaCalendarCliente();
                }}
                userName={userName}
                espacio={espacioData.nombre}
                reservationDate={formattedStartDate}
                startTime={formatTime(horaInicio + 14)}
                endTime={formatTime(horaFinal + 14)}
            />
            <Modal isOpen={cedulaRucModalIsOpen}
                onRequestClose={() => setCedulaRucModalIsOpen(false)} className="MensajeReserva">
                <h2 className={modalTitle === '¡Genial!' ? 'positive-message' : 'negative-message'} > Lo sentimos</h2>
                <h2>Debe ingresar su cédula o RUC para continuar con la reserva</h2>
                <input
                    type="text"
                    value={cedulaRuc}
                    onChange={handleChange2}
                    placeholder="Ingrese cédula o RUC"
                    maxLength={13} // Limitar la longitud a 13 caracteres (para RUC)
                />
                <button onClick={handleSubmit}>Guardar</button>
            </Modal>
            {/* Mostrar el modal de error si la cédula o RUC no es válida */}
            <Modal isOpen={errorModalIsOpen} onRequestClose={() => setErrorModalIsOpen(false)} className="ErrorModal">
                <h2 style={{ color: 'red' }}>Error</h2>
                <p>{errorMessage}</p>
                <button onClick={() => setErrorModalIsOpen(false)}>Cerrar</button>
            </Modal>
            {/* Mostrar el modal de éxito cuando la cédula o RUC se guarden correctamente */}
            <Modal isOpen={successModalIsOpen} onRequestClose={() => setSuccessModalIsOpen(false)} className="SuccessModal">
                <h2 style={{ color: 'green' }}>¡Éxito!</h2>
                <p>Cédula o RUC guardado correctamente.</p>
                <button  onClick={() => { handleReservation();setQrCodeModalIsOpen(true); setSuccessModalIsOpen(false) }} >Cerrar</button>
            </Modal>
            <Footer/>
        </div>
    )
}
export default ReservationsPage;